import { TextStyle } from '@optimus-web/common';

export const NORMAL = {
    textStyle: TextStyle.highlightMedium,
    showSymbol: true,
    precision: 2,
};

export const SMALL = {
    textStyle: TextStyle.highlightSmall,
    showSymbol: true,
    precision: 0,
};

export const XSMALL = {
    textStyle: TextStyle.highlightSmall,
    showSymbol: false,
    precision: 0,
};

const OFFSET = 70;

export const determineItemFitStyle = (parentWidth: number, totalChildWidth: number) => {
    if (parentWidth < 0 || totalChildWidth < 0) return SMALL;

    const difference = parentWidth - totalChildWidth;

    if (difference < 0) {
        return XSMALL;
    }

    if (difference > OFFSET) {
        return NORMAL;
    }

    return SMALL;
};
